import i18next from 'i18next'
import React from 'react'
import { TextPageHeader } from '../../pageHeader/pageHeaderLayout'
import { ViewListenerState } from '../../viewListener/viewListenerState'

export const ComponentOverviewWrapperLayout = (props: {
  totalComponentsCount?: number
  componentsCount?: number
  topFiltersContent: JSX.Element
  categoriesFilterContent: JSX.Element
  componentTeasersContent: JSX.Element
  paginationContent: JSX.Element
  view: ViewListenerState
}) => {
  return (
    <>
      <TextPageHeader
        title={i18next.t('component:componentsTitle_plural')}
        intro={i18next.t('component:componentsIntro', { componentCount: props.totalComponentsCount })}
        hasBorder={true}
      />

      <div className="components-filter c-filter" aria-live="assertive">
        <div className="c-filter__inner container--m gutter--m spacing--s">
          {/* Sidebar */}
          {props.categoriesFilterContent}

          {/* Main content */}
          <div className="c-filter__main">
            {/* Top filter */}
            {props.topFiltersContent}

            {/* Component count */}
            {props.view == 'desktop' && props.componentsCount != undefined && (
                <p
                    dangerouslySetInnerHTML={{
                        __html: i18next.t(
                            props.componentsCount === 1
                                ? 'componentFilter:componentCount'
                                : 'componentFilter:componentCount_plural',
                            {count: props.componentsCount}
                        ),
                    }}
                />
            )}

              {/* Components */}
              <section className="block block--component-teasers component-teasers--component-overview cf">
                  {props.componentTeasersContent}
              </section>

              {/* Pagination */}
              {props.paginationContent}
          </div>
        </div>
      </div>
    </>
  )
}
